import { Component, OnInit } from '@angular/core';
import { DeluxyFlowersSaleFormDialogComponent } from './../deluxy-flowers-sale-form-dialog/deluxy-flowers-sale-form-dialog.component';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AllSalesService } from 'src/app/services/all-sales.service';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { BusinessSaleService } from 'src/app/services/business-sale.service';
import { DeliveryService } from 'src/app/services/delivery.service';
import { ShopifySaleFormDialogComponent } from '../shopify-sale-form-dialog/shopify-sale-form-dialog.component';
import { CakeSaleFormDialogComponent } from '../cake-sale-form-dialog/cake-sale-form-dialog.component';
import { BusinessSaleFormDialogComponent } from '../business-sale-form-dialog/business-sale-form-dialog.component';
import { ShopifySaleService } from 'src/app/services/shopify-sale.service';
import { CakeSaleService } from 'src/app/services/cake-sale.service';
import { FlowersSaleService } from 'src/app/services/flowers-sale.service';
import { CakeOrderService } from 'src/app/services/cake-order.service';
import { AiCakeOrderInfoModalComponent } from '../ai-cake-order-info-modal/ai-cake-order-info-modal.component';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ShopifySale } from 'src/app/models/shopify-sale.schema';
import { CommanUsesService } from 'src/app/services/comman-uses.service';
import { CustomPaymentsService } from 'src/app/services/custom-payments.service';
import { CustomSalePaymentStatus } from 'src/app/models/custom-sale.schema';
import { DeliveryLinkDialogComponent } from '../delivery-link-dialog/delivery-link-dialog.component';
import * as ExcelJS from 'exceljs';
import { formatCurrency, formatDate } from '@angular/common';
import * as FileSaver from 'file-saver';
import { OperationService } from 'src/app/services/operation.service';
import { Operation } from 'src/app/models/operation.schema';
import { DeluxyDotComSaleFormDialogComponent } from '../deluxy-dot-com-sale-form-dialog/deluxy-dot-com-sale-form-dialog.component';
import { DeluxyExperienceSaleFormDialogComponent } from '../deluxy-experience-sale-form-dialog/deluxy-experience-sale-form-dialog.component';
import { DeluxyDotComSalesService } from 'src/app/services/deluxy-dot-com-sales.service';
import { DeluxyExperienceSalesService } from 'src/app/services/deluxy-experience-sales.service';

@Component({
  selector: 'app-all-sales',
  templateUrl: './all-sales.component.html',
  styleUrls: ['./all-sales.component.scss']
})

export class AllSalesComponent implements OnInit {

  limit: number;
  page: number;
  count: number;
  maxPage: number;
  filtered: {};
  orders: string[];
  allSaleForm: any;
  order: {};
  myjson:any=JSON;
  groups: any;
  selected: string = 'active';
  settings = {
    active: {
      title: "All Vendite",
    },
    inactive: {
      title: "Storico All Vendite",
    }
  };
  defaultPage = 1;
  defaultLimit = 20;
  defaultOrder = { 'createdAt': 'DESC' };
  btnDisable: boolean = false;
  cakeOrders: any[] = [];
  isLoading: boolean = false;
  allSaleOrders: any[] = [];
  operations: Operation[] = [];

  constructor(
    private authStatusService: AuthStatusService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private router: Router,
    private deliveryService: DeliveryService,
    private allSalesService: AllSalesService,
    private shopifySaleService: ShopifySaleService,
    private businessSaleService: BusinessSaleService,
    private cakeSaleService: CakeSaleService,
    private deluxyDotComSalesService: DeluxyDotComSalesService,
    private deluxyExperienceSalesService: DeluxyExperienceSalesService,
    private flowersSaleService: FlowersSaleService,
    private cakeOrderService: CakeOrderService,
    private spinnerService: SpinnerService,
    private commanUsesService: CommanUsesService,
    private customPaymentsService: CustomPaymentsService,
    private operationService: OperationService,
  ) {
    try {
      this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    } catch (error) {
      this.groups = [];
    }
  }
  
  async ngOnInit() { 
    try {
      this.spinnerService.show();
      this.selected = !this.route.snapshot.data['active'] ? 'inactive' : 'active';
      this.cakeOrders = await this.cakeOrderService.getAll();
      this.operations = await this.operationService.getAllOperations(1, 1000, null, null);
      this.manageAllSalesFilterForm();
      await this.filter();
    } catch (error) {
      this.showSnackBar("Something went wrong on this page");
    } finally {
      this.spinnerService.hide();
    }
  }

  manageAllSalesFilterForm() {
    this.allSaleForm = new FormGroup({
      'id': new FormControl(''),
      'orderId': new FormControl(''),
      'platform': new FormControl(''),
      'actualOrderId': new FormControl(''),
      'firstName': new FormControl(''), 
      'deliveryDate_from': new FormControl(''), 
      'deliveryDate_to': new FormControl(''),   
      'lastName': new FormControl(''),  
      'channel': new FormControl(''),
      'total': new FormControl(''),
      'totalDeliveryCost': new FormControl(''),
      'paymentStatus': new FormControl(''),
      'fullFillmentStatus': new FormControl(''),
      'deliveryMethod': new FormControl(''),
      'address': new FormControl(''),
      'pickUpTime': new FormControl(''),
      'phone': new FormControl(''),
      'deliveryDate': new FormControl(''),
      'vendor': new FormControl(''),
      'status': new FormControl(''),
      'confirmedBy': new FormControl(''),
    });
  }
  
  async filter() {
    let filterForm = (new FormGroupToObject()).transform(this.allSaleForm);
    this.filtered = {};
    if (filterForm['id'])
      this.filtered['id'] = filterForm['id'];    
    if (filterForm['orderId'])
      this.filtered['orderId'] = filterForm['orderId'];    
    if (filterForm['actualOrderId'])
      this.filtered['actualOrderId'] = filterForm['actualOrderId'];    
    if (filterForm['firstName'])
      this.filtered['firstName'] = { operator: 'like', values: [`%${filterForm['firstName']}%`] };
    if (filterForm['channel'])
      this.filtered['channel'] = { operator: 'like', values: [`%${filterForm['channel']}%`] };
    if (filterForm['total'])
      this.filtered['total'] = { operator: 'like', values: [`%${filterForm['total']}%`] };
    if (filterForm['totalDeliveryCost'])
      this.filtered['totalDeliveryCost'] = { operator: 'like', values: [`%${filterForm['totalDeliveryCost']}%`] };
    if (filterForm['paymentStatus'])
      this.filtered['paymentStatus'] = { operator: 'like', values: [`%${filterForm['paymentStatus']}%`] };
    if (filterForm['fullFillmentStatus'])
      this.filtered['fullFillmentStatus'] = { operator: 'like', values: [`%${filterForm['fullFillmentStatus']}%`] };
    if (filterForm['deliveryMethod'])
      this.filtered['deliveryMethod'] = { operator: 'like', values: [`%${filterForm['deliveryMethod']}%`] };
    if (filterForm['address'])
      this.filtered['address'] = { operator: 'like', values: [`%${filterForm['address']}%`] };
    if (filterForm['pickUpTime'])
      this.filtered['pickUpTime'] = { operator: 'like', values: [`%${filterForm['pickUpTime']}%`] };
    if (filterForm['phone'])
      this.filtered['phone'] = { operator: 'like', values: [`%${filterForm['phone']}%`] };
    if (filterForm['deliveryDate_from'])
      this.filtered['deliveryDate'] = { operator: 'moreThanOrEqual', values: [filterForm['deliveryDate_from']] };
    if (filterForm['deliveryDate_to'])
      this.filtered['deliveryDate'] = { operator: 'lessThan', values: [filterForm['deliveryDate_to']] };
    if (filterForm['deliveryDate_from'] && filterForm['deliveryDate_to'])
      this.filtered['deliveryDate'] = { operator: 'between', values: [filterForm['deliveryDate_from'], filterForm['deliveryDate_to']] };
    if (filterForm['vendor'])
      this.filtered['vendor'] = { operator: 'like', values: [`%${filterForm['vendor']}%`] };
    if (filterForm['status'])
      this.filtered['status'] = { operator: 'like', values: [`%${filterForm['status']}%`] };
    if (filterForm['platform'])
      this.filtered['platform'] = { operator: 'like', values: [`%${filterForm['platform']}%`] };
    if (filterForm['confirmedBy'])
      this.filtered['confirmedBy'] = { operator: 'like', values: [`%${filterForm['confirmedBy']}%`] };
  
    await this.getAllSalesOrders();
  }

  async getAllSalesOrders(limit?: number, page?: number, order?: {}){

    this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
    this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
    this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;
    let promiseResult = null;
    promiseResult = this.selected == 'active' ? 
      this.allSalesService.getAllSalesOrders(this.page, this.limit, this.order, this.filtered) :
      this.allSalesService.getAllSalesOrdersHistory(this.page, this.limit, this.order, this.filtered);
    promiseResult.then((res) => {
      this.orders = res.allSales;
      this.allSaleOrders = res.allSales || [];
      this.count = res.saleCount;
      this.maxPage = Math.ceil(this.count / this.limit);
    }).catch((err) => {
      console.log("err", err)
    })
  }

  async confirmSale(saleOrder: any, platform: string) {
    if(this.groups.includes('admin') || this.groups.includes('operation') || this.groups.includes('teamleader')){
      let delivery = await this.deliveryService.getDeliveryWithOrderId(saleOrder?.orderId, saleOrder?.realOrderNumber);
      if(delivery){
        this._snackBar.open(`This is unique product sale. Delivery has been created. Partner is still accpet or reject the sale`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
        return false;
      }

      let ref: any;
      if(platform === 'cakesales'){
        ref = this.dialog.open(CakeSaleFormDialogComponent, { width: '80vw', data: { saleOrder } });
      }
      if(platform === 'flowerssales'){
        ref = this.dialog.open(DeluxyFlowersSaleFormDialogComponent, { width: '80vw', data: { saleOrder } });
      }
      if(platform === 'shopifysale'){
        ref = this.dialog.open(ShopifySaleFormDialogComponent, { width: '80vw', data: { saleOrder } });
      }
      if(platform === 'businesssales'){
        ref = this.dialog.open(BusinessSaleFormDialogComponent, { width: '80vw', data: { saleOrder } });
      }
      if(platform === 'deluxydotcomsales'){
        ref = this.dialog.open(DeluxyDotComSaleFormDialogComponent, { width: '80vw', data: { saleOrder } });
      }
      if(platform === 'deluxyexperiencesales'){
        ref = this.dialog.open(DeluxyExperienceSaleFormDialogComponent, { width: '80vw', data: { saleOrder } });
      }
      
      ref.afterClosed().subscribe(result => {
        if (result?.delivery){
          this.getAllSalesOrders();
        }
      });
    } else {
      return false;
    }
  }

  async refuseSale(order: any, platform: string){
    if(!confirm(`Sei sicuro di voler rifiutare l'ordine di Shopify ${platform?.toUpperCase()}?`))
      return false;

    let promiseResult: any;
    if(platform === 'cakesales'){
      promiseResult = await this.cakeSaleService.refuseSaleByAdmin(order.id);
    }
    if(platform === 'flowerssales'){
      promiseResult = await this.flowersSaleService.refuseSaleByAdmin(order.id);
    }
    if(platform === 'shopifysale'){
      promiseResult = await this.shopifySaleService.refuseSaleByAdmin(order.id);
    }
    if(platform === 'businesssales'){
      promiseResult = await this.businessSaleService.refuseSaleByAdmin(order.id);
    }
    if(platform === 'deluxydotcomsales'){
      promiseResult = await this.deluxyDotComSalesService.refuseSaleByAdmin(order.id);
    }
    if(platform === 'deluxyexperiencesales'){
      promiseResult = await this.deluxyExperienceSalesService.refuseSaleByAdmin(order.id);
    }

    if(promiseResult.success){
      this._snackBar.open(`L'ordine di Shopify è stato rifiutato. Puoi controllare nella cronologia`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
      await this.getAllSalesOrders();
    } else {
      this._snackBar.open(`Qualcosa è andato storto`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
    }
  }

  async resetFilter() { 
    await this.manageAllSalesFilterForm();
    await this.filter();
  }

  openInNewTab(id: number, platform: string): void {
    const route = this.redirect(id, platform);  // This will now be an array
    const url = this.router.serializeUrl(this.router.createUrlTree(route));
    window.open(url, '_blank');  // Opens the route in a new tab
  }

  redirect(id: number, order: any): string[] {
    let route: string[] = [];
    const platform = order?.platform?.toLowerCase();

    if (order?.customSale) {
      return ['/custom/sales/edit', platform, order.id];
    }

    if (platform === 'cakesales') {
      route = ['/cakes/vendita/edit', id.toString()];
    } else if (platform === 'flowerssales') {
      route = ['/flowers/vendita/edit', id.toString()];
    } else if (platform === 'shopifysale') {
      route = ['/vendita/edit', id.toString()];
    } else if (platform === 'businesssales') {
      route = ['/business/vendita/edit', id.toString()];
    } else if (platform === 'customsale') {
      route = ['/custom/sales/edit', id.toString()];
    } else if (platform === 'deluxydotcomsales') {
      route = ['/deluxy-dot-com/vendita/edit', id.toString()];
    } else if (platform === 'deluxyexperiencesales') {
      route = ['/deluxy-experience/vendita/edit', id.toString()];
    }
    return route; 
  }

  openInNewTabEdit(order: any): void {
    const route = this.getRouterLink(order);
    const url = this.router.serializeUrl(this.router.createUrlTree(route));
    window.open(url, '_blank');
  }

  getRouterLink(order: any): string[] {
    const platform = order?.platform?.toLowerCase();

    if (order?.customSale) {
      return ['/custom/sales/edit', platform, order.id];
    }

    switch (platform) {
      case 'businesssales':
        return ['/business/vendita/edit', order.id];
      case 'shopifysale':
        return ['/vendita/edit', order.id];
      case 'flowerssales':
        return ['/flowers/vendita/edit', order.id];
      case 'cakesales':
        return ['/cakes/vendita/edit', order.id];
      case 'customsale':
        return ['/custom/sales/edit', order.id];
      case 'deluxydotcomsales':
        return ['/deluxy-dot-com/vendita/edit', order.id];
      case 'deluxyexperiencesales':
        return ['/deluxy-experience/vendita/edit', order.id];
      default:
        return ['/vendita']; // Default route if no match is found
    }
  }

  async stopSaleAutomation(sale: any){
    if(!confirm(`Are You Sure to Stop Sale Automation ${sale?.platform?.toLowerCase()}?`))
      return false;
    try {
      this.btnDisable = true;
      let id: number = sale?.id;
      let salePlatform = sale?.platform?.toLowerCase();
      let promiseResult: any;

      if(salePlatform === 'cakesales'){
        promiseResult = await this.cakeSaleService.stopSaleAutomation(id, sale);
      }
      if(salePlatform === 'flowerssales'){
        promiseResult = await this.flowersSaleService.stopSaleAutomation(id, sale);
      }
      if(salePlatform === 'shopifysale'){
        promiseResult = await this.shopifySaleService.stopSaleAutomation(id, sale);
      }
      if(salePlatform === 'businesssales'){
        promiseResult = await this.businessSaleService.stopSaleAutomation(id, sale);
      }
      if(salePlatform === 'deluxydotcomsales'){
        promiseResult = await this.deluxyDotComSalesService.stopSaleAutomation(id, sale);
      }
      if(salePlatform === 'deluxyexperiencesales'){
        promiseResult = await this.deluxyExperienceSalesService.stopSaleAutomation(id, sale);
      }

      if(promiseResult.success){
        this._snackBar.open(`Sale Automation has been Stopped.`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
      } else {
        this._snackBar.open(`Something Went Wrong`, 'Chiudi', {
          direction: "ltr",
          duration: 2000,
          horizontalPosition: "center",
          politeness: "assertive",
          verticalPosition: "top"
        });
      }
      await this.getAllSalesOrders();
    } catch (error) {
      this.btnDisable = false;
      this._snackBar.open(`Something Went Wrong ${error?.error?.message}`, 'Chiudi', {
        direction: "ltr",
        duration: 2000,
        horizontalPosition: "center",
        politeness: "assertive",
        verticalPosition: "top"
      });
    }
  }

  async showAiInfo(order: any){
    const lineItems = JSON.parse(order?.lineItems || '[]');
    lineItems.some((item: any) =>
      item.properties?.some((property: any) =>
        property.name.toLowerCase() === 'ai_cake_image_url' && property.value
          ? this.dialog.open(AiCakeOrderInfoModalComponent, { width: '80vw', data: { order } })
          : false
      )
    );
  }

  
  showBtnAiBtn(order: any): boolean {
    return this.cakeOrders.some((cakeOrder) => {
      return cakeOrder.realOrderNumber === order?.realOrderNumber && cakeOrder.orderId === order?.orderId;
    });
  }

  async navigate(event) {
    await this.getAllSalesOrders(event.limit, event.page, this.order);
  }

  public async navigateOrder(attribute: string | string[]) {
    delete this.order['BusinessSales.updatedAt'];
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          this.order[attr] = 'DESC';
          break;
        case 'DESC':
          this.order[attr] = undefined;
          break;
        default:
          this.order = {}
          this.order[attr] = 'ASC';
          break;
      }
    }

    await this.navigatePage(this.limit, this.page, { order: this.order });
  }

  async navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(async (data) => {
      await this.getAllSalesOrders();
    });
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    for (let attr of attribute) {
      switch (this.order[attr]) {
        case 'ASC':
          return 'fa-sort-up';
        case 'DESC':
          return 'fa-sort-down';
        default:
          return 'fa-sort';
      }
    }
  }

  showSnackBar(message: string){
    this._snackBar.open(message, 'Chiudi', {
      direction: "ltr",
      duration: 2000,
      horizontalPosition: "center",
      politeness: "assertive",
      verticalPosition: "top"
    });
  }

  async removeDeliveryForUniqueSale(order: any){
    try {
      let data = {
        "id": order.id,
        "shop": order.platform
      }

      let promise = this.deliveryService.removeDeliveryForUniqueSale(data);
      promise.then(async (res: any) => {
        // if(res){
          await this.getAllSalesOrders();
          this.showSnackBar("Sale has been canceled. Now admin can handle this sale");
        // }
      }).catch(async (err: any) => {
        if(err?.error?.message === 'CAN_NOT_INTRUPT_DELIVERY_IS_UNDERGOING') {
          this.showSnackBar(err?.error?.message);
        } else {
          this.showSnackBar(err?.error?.message || "SOMETHING_WENT_WRONG");
        }
      })
    } catch (error) {
      console.log("Error", error?.message);
    }
  }

  showDeliveryPrice(shopifySale: ShopifySale) {

    if(shopifySale?.totalShippingAmount && shopifySale?.totalShippingAmount > 0) {
      return Number(shopifySale?.totalShippingAmount) || 0;
    }
    if(shopifySale?.totalShippingPriceSet){
      let shippingPriceSet = JSON.parse(shopifySale?.totalShippingPriceSet);
      return Number(shippingPriceSet?.shop_money?.amount) || 0;
    }
    return 0;
  }

  async generateLink(order) {
    try {
      this.isLoading = true;
      const platform = order?.platform?.toLowerCase();
      if(order?.customSale) {
        await this.customSaleLink(order);
        this.isLoading = false;
      } else {
        await this.shopsSaleLink(order);
        this.isLoading = false;
      }
    } catch (error) {
      this.commanUsesService.showSnackBar(`${error?.message}`);
      this.isLoading = false;
    }
  }

  async sendEmailToCustomer(order) {
    try {
      this.isLoading = true;
      const shop = order?.platform?.toLowerCase();
      const aliasMap: Record<string, string> = {
        shopifysale: 'deluxy',
        cakesales: 'cake',
        flowerssales: 'flowers',
        businesssales: 'business',
        deluxydotcomsales: 'deluxy-dot-com',
        deluxyexperiencesales: 'deluxy-experience',
      };
      const platform = aliasMap[shop];
      const result: boolean = await this.customPaymentsService.sendEmailToCustomer(order, platform);

      if(result) {
        this.commanUsesService.showSnackBar('EMAIL_SENT_TO_THE_CUSTOMER');
      } else {
        this.commanUsesService.showSnackBar('SOMETHING_WENT_WRONG');
      }
    } catch (error) {
      const errMsg = error?.error?.message || error?.message;
      this.commanUsesService.showSnackBar(errMsg);
    } finally {
      this.isLoading = false;
    }
  }

  async shopsSaleLink(order: any) { 
    try {
      const platform = order?.platform?.toLowerCase();
      let sale = await this.customPaymentsService.getSaleWithDeliveryInfo(order.id, platform);
      /*
      if(sale?.deliveries?.length === 0) {
        this.commanUsesService.showSnackBar("NO_DELIVERIES_CREATED_YET_FOR_THIS_SALE");
        return;
      }
      */
      this.dialog.open(DeliveryLinkDialogComponent, { width: '80vw', data: { delivery: sale, type: 'shopSale' } });
    } catch (error) {
      this.commanUsesService.showSnackBar(`${error?.message}`);
    }
  }

  async customSaleLink(order) {
    try {
      // const customSale = await this.customPaymentsService.createCheckoutSession(order.id);
      if(order?.customSalePaymentStatus === CustomSalePaymentStatus.toBePaid) {
        alert('Il pagamento per questa vendita è in sospeso.');
        return;
      }

      let sale = await this.customPaymentsService.getCustomSaleWithDeliveryInfo(order.id, order?.platform?.toLowerCase());

      if(sale?.deliveries?.length === 0) {
        this.commanUsesService.showSnackBar("NO_DELIVERIES_CREATED_YET_FOR_THIS_SALE");
        return;
      }

      this.dialog.open(DeliveryLinkDialogComponent, { width: '80vw', data: { delivery: sale, type: 'shopSale' } });
    } catch (error) {
      let errMsg = error?.message || 'Something went wrong';
      this.commanUsesService.showSnackBar(errMsg);
    } finally {

    }
  }

  async export() {
    let res;
    await this.generateXl();
  }

  async generateXl() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Finance Report');

    const headers = [
      'PLATFORM',
      'ORDINE', 
      'CONFERMA TIPO', 
      'DATA ORDINE', 
      'CLIENTE', 
      'INDIRIZZO',
      'TELEFONO', 
      'CANALE', 
      'TOTALE', 
      'COSTO CONSEGNA',
      'STATO DEL PAGAMENTO', 
      'STATO DI ADEMPIMENTO', 
      'ELEMENTI', 
      'SKU',
      'METODO DI CONSEGNA', 
      'VENDOR', 
    ];

    worksheet.addRow(headers).eachCell((cell) => {
      cell.font = { bold: true };
    });

    for(let saleOrder of this.allSaleOrders) {
      const euro = (value: number) => formatCurrency(value || 0, 'it', '€', 'EUR', '1.2-2');
      const formatDateIt = (value: any): string => {
        if (!value || typeof value !== 'string' || value.trim() === '') {
          return 'N/A';
        }

        const date = new Date(value);
        if (isNaN(date.getTime())) {
          return 'N/A';
        }

        return formatDate(date, 'fullDate', 'it');
      };

      const rowData = [
        this.findPlatform(saleOrder),
        Number(saleOrder.actualOrderId),
        this.selected === 'active' ? "N/A" : saleOrder?.confirmedBy?.toUpperCase() || "N/A",
        formatDateIt(saleOrder.deliveryDate),
        [saleOrder.firstName, saleOrder.lastName].filter(Boolean).join(' ') || 'N/A',
        saleOrder.address || 'N/A',
        saleOrder.phone || 'N/A',
        saleOrder.channel || 'N/A',
        euro(Number(saleOrder.total ?? 0)),
        euro(Number(this.showDeliveryPrice(saleOrder))),
        saleOrder.paymentStatus || 'N/A',
        saleOrder.fullFillmentStatus || 'UNFULLFILLED',
        this.joinLineItemField(saleOrder.lineItems, 'name'),
        this.joinLineItemField(saleOrder.lineItems, 'sku'),
        saleOrder.deliveryMethod || 'N/A',
        saleOrder.vendor || 'N/A',
      ];

      const row = worksheet.addRow(rowData);      
    }

    worksheet.columns.forEach((col) => {
      let maxLength = 10;
      col.eachCell({ includeEmpty: true }, (cell) => {
        const value = cell.value ? cell.value.toString() : '';
        maxLength = Math.max(maxLength, value.length);
      });
      col.width = maxLength + 2;
    });

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      FileSaver.saveAs(blob, 'tutte-le-vendite.xlsx');
    });

  }

  findPlatform(order: any) {
    const platform = order?.platform?.toLowerCase();
    if (!platform) return 'N/A';

    switch (platform) {
      case 'businesssales':
        return 'BUSINESS';

      case 'shopifysale':
        return 'DELUXY';

      case 'cakesales':
        return 'CAKE';

      case 'flowerssales':
        return 'FLOWER';

      case 'customsale':
        return 'CUSTOMSALE';

      case 'deluxydotcomsales':
        return 'DELUXY DOT COM';

      case 'deluxyexperiencesales':
        return 'DELUXY EXPERIENCE';

      default:
        return 'N/A';
    }
  }

  private parseLineItems(lineItems: any): any[] {
    if (!lineItems) return [];

    try {
      const parsed = typeof lineItems === 'string'
        ? JSON.parse(lineItems)
        : lineItems;

      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private joinLineItemField(
    lineItems: any,
    field: 'name' | 'sku',
    fallback = 'N/A'
  ): string {
    const items = this.parseLineItems(lineItems);

    const values = items
      .map(item => item?.[field])
      .filter(v => typeof v === 'string' && v.trim() !== '');

    return values.length ? values.join(', ') : fallback;
  }

  showWhoConfirm(order) {

    const createdUser = this.operations.find((op) => Number(op.user.id) === Number(order?.delivery?.createdUser));
    if(createdUser) {
      return createdUser.user.name + ' ' + createdUser.user.surname;
    } else {
      if(order?.confirmedBy?.toLowerCase() === 'partner') return "PARTNER";
      if(order?.confirmedBy?.toLowerCase() === 'admin') return "ADMIN";
      //if(order?.status?.toLowerCase() === 'refused') return "REFUSED";
      return "N/A";
    }
  }

  isValidDate(date: any): boolean {
    const parsedDate = new Date(date);
    return !isNaN(parsedDate.getTime());
  }

  getOrderLabel(order: any, selected: string): string {
    const status = order?.status?.toLowerCase();
    const saleType = order?.saleType?.toLowerCase();
    const confirmedBy = order?.confirmedBy?.toLowerCase();

    if (selected === 'active') {

      if (status === 'new' && order?.rejectedByPartner) {
        return 'DA GESTIRE, NON ACCETTATA';
      }

      if (
        status === 'new' ||
        (status === 'notaccepted' && saleType !== 'unique') ||
        status === 'refused'
      ) {
        return 'Da Gestire';
      }

      if (status === 'confirmed' && confirmedBy === 'partner') {
        return 'Vendita Accettata';
      }

      if (status === 'confirmed' && (!confirmedBy || confirmedBy === 'admin')) {
        return 'Vendita Confermata';
      }

      if (status === 'emailed' && saleType === 'nonunique') {
        return 'Vendita Inviata a ' + (order?.assignedPartner || '');
      }

      if (
        (status === 'emailed' || status === 'notaccepted') &&
        saleType === 'unique'
      ) {
        return 'Inserita, Da Accettare';
      }

      return 'N/A';
    }

    if (selected === 'inactive') {

      if (status === 'new') return 'Da Gestire';

      if (status === 'confirmed' && confirmedBy === 'partner') {
        return 'Vendita Accettata';
      }

      if (status === 'confirmed' && (!confirmedBy || confirmedBy === 'admin')) {
        return 'Vendita Confermata';
      }

      if (status === 'refused') return 'Vendita Rifiutata';

      if (status === 'notaccepted') return 'Non accettato';

      if (status === 'emailed') return 'Vendita Inviata';

      return 'N/A';
    }

    return 'N/A';
  }

}